var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"main-content"},[_c('HeroNews'),_c('TodayMatches'),_c('topLeagues'),_c('LeagueStats')],1),_c('SidebarLeft')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }